'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldMappingRest = function () {
  function FieldMappingRest($http) {
    (0, _classCallCheck3.default)(this, FieldMappingRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      FIELD_MAPPING_LIST: 'field-mapping/',
      FIELD_MAPPING_DETAIL: 'field-mapping/%1$s/'
    };
  }

  (0, _createClass3.default)(FieldMappingRest, [{
    key: 'read',
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.FIELD_MAPPING_DETAIL, id));
    }
  }, {
    key: 'create',
    value: function create(postData) {
      return this.$http.post(this.PATH.FIELD_MAPPING_LIST, postData);
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      return this.$http.patch(this.sprintf(this.PATH.FIELD_MAPPING_DETAIL, id), postData);
    }
  }, {
    key: 'save',
    value: function save(postData) {
      return postData.id ? this.update(postData.id, postData) : this.create(postData);
    }
  }]);
  return FieldMappingRest;
}();

exports.default = FieldMappingRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/FieldMappingResource.js
// module id = 326
// module chunks = 0